import { lazy } from 'react';
import paths from '../paths';
import { createRoutes } from '../utils';

const Reports = lazy(() => import('../../components/pages/report/Reports'));

const role = 'admin';
const definitions = [{
  path: '/reports',
  children: [
    {
      path: paths.salesPaceReports,
      checkname: 'reports.sales_pace_reports.read',
      component: Reports,
      role,
    },
    {
      path: paths.salesPaceReportLineChart,
      checkname: 'reports.sales_pace_report_line_chart.read',
      component: Reports,
      role,
    },
    {
      path: paths.salesPerformanceReport,
      checkname: 'reports.sales_performance_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.salesPerformanceReportLineChart,
      checkname: 'reports.sales_performance_report_line_chart.read',
      component: Reports,
      role,
    },
    {
      path: paths.transactionPerformanceReport,
      checkname: 'reports.transaction_performance_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.retentionReport,
      checkname: 'reports.retention_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.affiliateSalesSummary,
      checkname: ['reports.affiliate_sale.read', 'reports.affiliate_sales_summary.read'],
      component: Reports,
      role: ['admin', 'affiliate'],
    },
    {
      path: paths.cancellationReasonsOrders,
      checkname: 'reports.cancellation_reasons_orders.read',
      component: Reports,
      role,
    },
    {
      path: paths.cancellationReasonsSubscriptions,
      checkname: 'reports.cancellation_reasons_subscriptions.read',
      component: Reports,
      role,
    },
    {
      path: paths.forecastedRebillsReport,
      checkname: 'reports.forecasted_rebills_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.conversionReport,
      checkname: 'reports.conversion_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.declineResponseReport,
      checkname: 'reports.decline_response_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.binRoutingPerformanceReport,
      checkname: 'reports.bin_routing_performance_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.varianceReport,
      checkname: 'reports.variance_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.cardProcessingReport,
      checkname: 'reports.card_processing_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.duplicateCustomerReport,
      checkname: 'reports.duplicate_customer_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.chargeBackSummaryReport,
      checkname: 'reports.chargeback_summary_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.fraudAnalysisReport,
      checkname: 'reports.fraud_analysis_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.fulfillmentSummaryReport,
      checkname: 'reports.fulfillment_summary_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.customerPurchaseAttemptsReport,
      checkname: 'reports.customer_purchase_attempts_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.revenueSummaryReport,
      checkname: 'reports.revenue_summary_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.dtcPopulatedFields,
      checkname: 'reports.dtc_populated_fields.read',
      component: Reports,
      role,
    },
    {
      path: paths.capProjectionsReport,
      checkname: 'reports.cap_projections_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.reprocessingReport,
      checkname: 'reports.reprocessing_report.read',
      component: Reports,
      role,
    },
    {
      path: paths.productsReport,
      checkname: 'reports.products_report.read',
      component: Reports,
      role,
    },
    {
      component: Reports,
      path: paths.negativesReport,
      role,
    },
  ],
}];

const dashboarDef = [{
  path: paths.dashboard,
  role: 'admin',
  component: Reports,
}];

export const reportRoutes = (abilities, role) => createRoutes(definitions, abilities, role);
export const dashboardRoutes = (abilities, role) => createRoutes(dashboarDef, abilities, role);
